/***************************************************************************************************
** getAuthenticityToken
***************************************************************************************************/

export default function getAuthenticityToken() {
  return document.querySelector("meta[name=\"csrf-token\"]")?.getAttribute("content");
}
